import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {Text} from '@/components/ui/text/Text'
import {useMissedAccessesCount} from '../../queries/useMissedAccessesCount'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useFormContext, useWatch} from 'react-hook-form'
import {CreateAbsenceFormValidationSchema} from '../../formSchemas'
import {useTranslation} from '@/translations/i18n'

export const MissedAccessesDisplay = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<CreateAbsenceFormValidationSchema>()
    const date = useWatch({control, name: 'date'})
    const project = useWatch({control, name: 'project'})

    const {count, isLoading} = useMissedAccessesCount({date, projectId: project?.id})

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{t('accesses:missed_accesses')}</Label>
            <Flexbox align="center" fullWidth style={{height: '32px'}}>
                {isLoading ? (
                    <Skeleton width="100%" height="20px" />
                ) : (
                    <Text size="textSm" palette="neutral" shade="600">
                        {count > 0 ? count : '-'}
                    </Text>
                )}
            </Flexbox>
        </Flexbox>
    )
}
